"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BatchTranscriptionErrorCode = exports.VoiceCommandError = void 0;
var VoiceCommandError;
(function (VoiceCommandError) {
    VoiceCommandError[VoiceCommandError["NoMatch"] = 0] = "NoMatch"; // The utterance couldn't be resolved to any command.
})(VoiceCommandError = exports.VoiceCommandError || (exports.VoiceCommandError = {}));
var BatchTranscriptionErrorCode;
(function (BatchTranscriptionErrorCode) {
    BatchTranscriptionErrorCode["INTERNAL_ERROR"] = "INTERNAL_ERROR";
    BatchTranscriptionErrorCode["UNSUPPORTED_FILE_FORMAT"] = "UNSUPPORTED_FILE_FORMAT";
})(BatchTranscriptionErrorCode = exports.BatchTranscriptionErrorCode || (exports.BatchTranscriptionErrorCode = {}));
//# sourceMappingURL=annotations.js.map